import { mainApi } from '../utils/api';

type BaseInput = {
  orgId: number;
  projectId: number;
};

export type GetActualDataInput = BaseInput;

export type ImportActualDataInput = BaseInput & {
  data: FormData;
};

export type DownloadActualDataTemplateFileInput = BaseInput & {
  templateName: string;
};

export type DownloadActualDataFileInput = BaseInput & {
  fileId: number;
};

export type DownloadAllActualDataFilesInput = BaseInput;

export type GetActualDataSchemasInput = BaseInput;

export type BaseInputType = BaseInput;

const baseUrl = ({ orgId, projectId }: BaseInputType) =>
  `organizations/${orgId}/projects/${projectId}/actual_data`;

const getActualData = ({ orgId, projectId }: GetActualDataInput) =>
  mainApi.get(
    `${baseUrl({
      orgId,
      projectId,
    })}`
  );

const getActualDataById = ({
  orgId,
  projectId,
  fileId,
}: DownloadActualDataFileInput) =>
  mainApi.get(
    `${baseUrl({
      orgId,
      projectId,
    })}/${fileId}`
  );

const getActualDataOutput = ({ orgId, projectId }: GetActualDataInput) =>
  mainApi.get(
    `${baseUrl({
      orgId,
      projectId,
    })}/data`
  );

const getActualDataSchemas = ({
  orgId,
  projectId,
}: GetActualDataSchemasInput) =>
  mainApi.get(
    `${baseUrl({
      orgId,
      projectId,
    })}/schema`
  );

const importActualData = ({ orgId, projectId, data }: ImportActualDataInput) =>
  mainApi.post(
    `${baseUrl({
      orgId,
      projectId,
    })}/import_files/`,
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

const downloadActualDataFile = ({
  orgId,
  projectId,
  fileId,
}: DownloadActualDataFileInput) =>
  mainApi.get(
    `${baseUrl({
      orgId,
      projectId,
    })}/${fileId}/download/`,
    {
      headers: {
        'Content-Type': 'application/octet-stream',
      },
      responseType: 'blob',
    }
  );

const downloadAllActualDataFiles = ({
  orgId,
  projectId,
}: DownloadAllActualDataFilesInput) =>
  mainApi.get(
    `${baseUrl({
      orgId,
      projectId,
    })}/download_all_files`,
    {
      headers: {
        'Content-Type': 'application/octet-stream',
      },
      responseType: 'blob',
    }
  );

const getDownloadingActualDataTemplate = ({
  orgId,
  projectId,
  templateName,
}: DownloadActualDataTemplateFileInput) =>
  mainApi.get(
    `${baseUrl({
      orgId,
      projectId,
    })}/download_template/?template_name=${templateName}`,
    {
      headers: {
        'Content-Type': 'application/octet-stream',
      },
      responseType: 'blob',
    }
  );

export {
  downloadActualDataFile,
  downloadAllActualDataFiles,
  getActualData,
  getActualDataById,
  getActualDataOutput,
  getActualDataSchemas,
  getDownloadingActualDataTemplate,
  importActualData,
};
